// Full updated UsersList component with sorting dropdown (A-Z / Z-A)

import React, { Component } from "react";
import {
  Col,
  Button,
  Row,
  InputGroup,
  Input,
  InputGroupAddon,
  Table
} from "reactstrap";
import { BsFillCheckCircleFill } from "react-icons/bs";
import { BiTrash } from "react-icons/bi";
import Select from "react-select";
import * as url from "./../../../utils/url";
import axios from "../../../axios";
import { connect } from "react-redux";
import OfficeMate from "../../office/OfficeMates/OfficeMate/OfficeMate";
import Loading from "../../../hoc/Loading/Loading";
import { withRouter } from "react-router";
import EmptyTable from "./../../../components/EmptyTable/EmptyTable";
import { isMobile } from "../../../utils/deviceInfo";
import { toastContainer } from "../../../utils/toast";
import UploadUsersModal from "../../trivia/Components/UploadUsersModal";
import * as actionCreators from "../../../modules/actions";
import UsersTableHeader from "./UsersTableHeading";



let searchDebounce;

const SORT_OPTIONS = [
  { value: "default", label: "Default" },
  { value: "az", label: "A → Z" },
  { value: "za", label: "Z → A" },
];

class UsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      officeMates: [],
      searchedTerm: "",
      displayUsers: [],
      pageNum: 1,
      pageLimit: 20,
      totalUsers: 0,
      searchTotalUsers: 0,
      usersRemove: [],
      matchedKeys: [],
      columnNames:[],
      isSearchActive: false,
      isSearching: false,
      sortMode: "default",
      sortOrder:'',
      selectedSortOption: SORT_OPTIONS[0],
      loading:false
    };
  }

  componentDidMount() {
    this.getOfficeMates(this.props.type);
    this.getOrgUserMetaData();
  }

  getOrgUserMetaData = () => {
    axios
      .get(url.getOrgUserMetaData)
      .then(({ data }) => {
        const meta = data.data.data;
        if (!meta) return;
        this.setState({ matchedKeys: meta.matchedKeys,columnNames:meta.columnNames });
      })
      .catch((error) =>
        console.error("Error fetching org user metadata", error)
      );
  };


  // Frontend (opens in NEW TAB; no memory buffering; works with cookie/session auth)
  downloadAllUsers = () => {
    console.log(url.getDownloadLink,'link here')
    this.setState({loading:true})
    axios
      .get(url.getDownloadLink) // this call IS authenticated
      .then((res) => {
        this.setState({loading:false})
        window.open(res.data.url, "_blank", "noopener");
      })
      .catch((err) => console.error("Error getting signed link:", err));
  };
  getOfficeMates = (val, page = 1) => {
    const { pageLimit, sortMode ,sortOrder} = this.state;
    console.log("inside office mated",sortMode,sortOrder)
    axios
      .get(url.fetchUsers, {
        params: { pageNum: page, pageLimit, sort: sortMode,sortOrder },
      })
      .then((response) => {
        const users = response.data.data;
        const total = response.data.meta.totalCount || users.length;
        this.setState({
          officeMates: users,
          displayUsers: users,
          pageNum: page,
          totalUsers: total,
          isSearchActive: false,
          usersRemove: [],
        });
        this.props.getUserCount && this.props.getUserCount(total);
      })
      .catch((error) => console.log(error));
  };

  getSearchResults = (text, page = 1) => {
    const { pageLimit, sortMode } = this.state;
    this.setState({ isSearching: true });
    axios
      .get(url.searchUsersForListing, {
        params: { pageNum: page, pageLimit, searchText: text, sort: sortMode },
      })
      .then((response) => {
        const users = response.data.data;
        const total = response.data.meta.totalCount || users.length;
        this.setState({
          displayUsers: users,
          pageNum: page,
          searchTotalUsers: total,
          isSearchActive: true,
          isSearching: false,
          usersRemove: [],
        });
      })
      .catch((error) => {
        console.log("Search error:", error);
        this.setState({ isSearching: false });
      });
  };

  getSearchResults = (text, page = 1) => {
    const { pageLimit, sortMode } = this.state;
    this.setState({ isSearching: true });
    axios
      .get(url.searchUsersForListing, {
        params: {
          pageNum: page,
          pageLimit,
          searchText: text,
          sort: sortMode,
        },
      })
      .then((response) => {
        const users = response.data.data;
        const total = response.data.meta.totalCount || users.length;
        this.setState({
          displayUsers: users,
          pageNum: page,
          searchTotalUsers: total,
          isSearchActive: true,
          isSearching: false,
          usersRemove: [],
        });
      })
      .catch((error) => {
        console.log("Search error:", error);
        this.setState({ isSearching: false });
      });
  };

  handleSearchQueryChanged = ({ target }) => {
    const value = target.value;
    clearTimeout(searchDebounce);
    this.setState({ searchedTerm: value });
    searchDebounce = setTimeout(() => {
      if (value.trim() === "") {
        this.clearSearch();
      } else {
        this.getSearchResults(value.trim(), 1);
      }
    }, 300);
  };

  handleEmailChange = (updatedUser) => {
    this.setState((prevState) => ({
      officeMates: prevState.officeMates.map((user) =>
        user._id === updatedUser._id
          ? { ...user, email: updatedUser.email, isDummyEmail: updatedUser.isDummyEmail }
          : user
      ),
      displayUsers: prevState.displayUsers.map((user) =>
        user._id === updatedUser._id
          ? { ...user, email: updatedUser.email, isDummyEmail: updatedUser.isDummyEmail }
          : user
      ),
    }));
  };

  handleMobileNumberChange = (updatedUser) => {
    this.setState((prevState) => ({
      officeMates: prevState.officeMates.map((user) =>
        user._id === updatedUser._id
          ? { ...user, mobileNumber: updatedUser.mobileNumber }
          : user
      ),
      displayUsers: prevState.displayUsers.map((user) =>
        user._id === updatedUser._id
          ? { ...user, mobileNumber: updatedUser.mobileNumber }
          : user
      ),
    }));
  };


  updateSortMode = (mode,order) => {
    this.setState({sortMode: mode,sortOrder:order},() => {
      const { pageNum } = this.state;
        this.getOfficeMates(this.props.type, pageNum);
      
    })
    
  };

  handleNameChange = (updatedUser) => {
    const { user: loggedInUser, updateUserProfile } = this.props
    const { firstName, lastName } = updatedUser

    if (updatedUser._id === loggedInUser._id) updateUserProfile({ firstName, lastName });
    this.setState((prevState) => ({
      officeMates: prevState.officeMates.map((user) =>
        user._id === updatedUser._id
          ? { ...user, firstName, lastName }
          : user
      ),
      displayUsers: prevState.displayUsers.map((user) =>
        user._id === updatedUser._id
          ? { ...user, firstName, lastName }
          : user
      ),
    }));
  };

  handleRoleChange = (updatedUser) => {
    const { _id, role, orgAdmin } = updatedUser;
    this.setState((prevState) => ({
      officeMates: prevState.officeMates.map((user) =>
        user._id === _id
          ? { ...user, role: role, orgAdmin: orgAdmin }
          : user
      ),
      displayUsers: prevState.displayUsers.map((user) =>
        user._id === _id
          ? { ...user, role: role, orgAdmin: orgAdmin }
          : user
      ),
    }));
    // Check if the user is changing their own role
    if (_id === this.props.user._id) {
      // Update Redux state for the current user
      const updatedUserProfile = {
        ...this.props.user,
        role: role,
        orgAdmin: orgAdmin
      };
      this.props.updateUserProfile(updatedUserProfile);
    }
  };

  clearSearch = () => {
    this.setState(
      { searchedTerm: "", isSearchActive: false, usersRemove: [], pageNum: 1 },
      () => {
        this.getOfficeMates(this.props.type, 1);
      }
    );
  };

  handleSortChange = (selectedOption) => {
    const sortMode =
      selectedOption.value === "az"
        ? "az"
        : selectedOption.value === "za"
          ? "za"
          : "default";

    this.setState({ sortMode, selectedSortOption: selectedOption }, () => {
      const { isSearchActive, searchedTerm, pageNum } = this.state;
      if (isSearchActive && searchedTerm) {
        this.getSearchResults(searchedTerm, pageNum);
      } else {
        this.getOfficeMates(this.props.type, pageNum);
      }
    });
  };

  removeMultipleUsers = () => {
    const {
      usersRemove,
      pageLimit,
      pageNum,
      isSearchActive,
      searchedTerm,
      totalUsers,
      loading
    } = this.state;
    axios
      .post(url.deleteMultipleUsers, { users: usersRemove })
      .then(() => {
        toastContainer("Users removed successfully", "success");
        const newTotalPages = Math.ceil((totalUsers - usersRemove.length) / pageLimit);
        const newPage = Math.min(pageNum, newTotalPages) || 1;
        this.setState({ usersRemove: [], pageNum: newPage }, () => {
          if (isSearchActive && searchedTerm) {
            this.getSearchResults(searchedTerm, newPage);
          } else {
            this.getOfficeMates(this.props.type, newPage);
          }
        });
      })
      .catch(() => {
        toastContainer("Error removing users", "error");
      });
  };

  userSelectedForRemove = (id) => {
    const { usersRemove } = this.state;
    const updated = usersRemove.includes(id)
      ? usersRemove.filter((uid) => uid !== id)
      : [...usersRemove, id];
    this.setState({ usersRemove: updated });
  };

  handlePageChange = (newPage) => {
    const { searchedTerm, isSearchActive } = this.state;
    if (isSearchActive && searchedTerm) {
      this.getSearchResults(searchedTerm, newPage);
    } else {
      this.getOfficeMates(this.props.type, newPage);
    }
  };

  renderPagination() {
    const {
      pageNum,
      pageLimit,
      isSearchActive,
      totalUsers,
      searchTotalUsers,
      displayUsers,
    } = this.state;
    const total = isSearchActive ? searchTotalUsers : totalUsers;
    const totalPages = Math.ceil(total / pageLimit);
    if (displayUsers.length === 0) return null;

    const currentPage = pageNum;
    const startPage = Math.max(2, currentPage - 2);
    const endPage = Math.min(totalPages - 1, currentPage + 2);

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button
            className="page-link rounded-circle mx-1"
            onClick={() => this.handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    return (
      <Row className="mt-1 mb-5">
        <Col className="d-flex justify-content-between align-items-center">
          <small className="text-muted mx-3 d-inline-flex align-items-center">
            Showing &nbsp; <strong>{(pageNum - 1) * pageLimit + 1}</strong>{" "}
            &nbsp;to&nbsp;{" "}
            <strong>{Math.min(pageNum * pageLimit, total)}</strong>&nbsp; of{" "}
            &nbsp;
            <strong>{total}</strong> &nbsp;results
          </small>
          <nav>
            <ul className="pagination justify-content-center">
              <li className={`page-item ${pageNum === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link rounded-circle mx-1"
                  onClick={() => this.handlePageChange(pageNum - 1)}
                >
                  &lsaquo;
                </button>
              </li>
              <li className={`page-item ${pageNum === 1 ? "active" : ""}`}>
                <button
                  className="page-link rounded-circle mx-1"
                  onClick={() => this.handlePageChange(1)}
                >
                  1
                </button>
              </li>
              {currentPage > 4 && (
                <li className="page-item disabled">
                  <span className="page-link mx-1">…</span>
                </li>
              )}
              {pages}
              {currentPage < totalPages - 3 && (
                <li className="page-item disabled">
                  <span className="page-link mx-1">…</span>
                </li>
              )}
              {totalPages > 1 && (
                <li
                  className={`page-item ${currentPage === totalPages ? "active" : ""
                    }`}
                >
                  <button
                    className="page-link rounded-circle mx-1"
                    onClick={() => this.handlePageChange(totalPages)}
                  >
                    {totalPages}
                  </button>
                </li>
              )}
              <li
                className={`page-item ${pageNum === totalPages ? "disabled" : ""
                  }`}
              >
                <button
                  className="page-link rounded-circle mx-1"
                  onClick={() => this.handlePageChange(pageNum + 1)}
                >
                  &rsaquo;
                </button>
              </li>
            </ul>
          </nav>
        </Col>
      </Row>
    );
  }

  render() {
    const {
      searchedTerm,
      displayUsers,
      usersRemove,
      selectedSortOption,
      loading,
      sortMode
    } = this.state;
    const { uploadUsersModal, setUploadUsersModal } = this.props;
console.log("old matched data:", this.state.matchedKeys)
    return (
      <div>
        {uploadUsersModal && (
          <UploadUsersModal
            open={uploadUsersModal}
            onClose={() => setUploadUsersModal(false)}
            uploadSuccess={() => {
              this.getOfficeMates(this.props.type);
              setUploadUsersModal(false);
            }}
            oldUsers={this.state.officeMates}
            oldMatchedKeys={this.state.matchedKeys}
            columnNames={this.state.columnNames}
          />
        )}

        <Row className="mt30 mlmr0 align-items-center">
          <Col sm={6}>
            <InputGroup style={{ height: "40px" }}>
              <Input
                className="toolkit-field tool-search-box"
                placeholder="Search..."
                autoComplete="off"
                onChange={this.handleSearchQueryChanged}
                value={searchedTerm}
              />
              {searchedTerm && (
                <InputGroupAddon addonType="append">
                  <Button color="secondary" onClick={this.clearSearch}>
                    ×
                  </Button>
                </InputGroupAddon>
              )}
            </InputGroup>
          </Col>
          <Col
            sm={6}
            className="d-flex justify-content-end align-items-center"
            style={{ gap: "10px" }}
          >
            <h4>Sort</h4>
            <div style={{ width: 140 }}>
              <Select
                name="sortSelect"
                value={selectedSortOption}
                options={SORT_OPTIONS.filter(
                  (v) => v.value !== selectedSortOption.value
                )}
                onChange={this.handleSortChange}
                isClearable={false}
              />
            </div>
          </Col>
        </Row>

        <div className="active-account-tag my-2 ml-3">
          <BsFillCheckCircleFill color="green" className="mr-1" size={14} />{" "}
          indicates user has logged in and activated account
        </div>

      
                {this.props.user.role.toLowerCase().includes('admin')  && (

                  <div style={{ display: 'flex', justifyContent: isMobile ? "center" : "flex-end", alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginBottom: '10px',marginRight: '10px' }}>

                  <Button onClick={ ()=> this.downloadAllUsers()} color="primary" size="sm" className={isMobile ? "mb-3" : "mb-0"} style={{minWidth: '150px'}} disabled={loading}>
                    {loading ? "Getting Data..." : "Download All Users"}
        
       </Button>
                  </div>
      )}

        {usersRemove.length > 0 && (
          <Button
            color="danger"
            size="sm"
            className="ml-3"
            onClick={this.removeMultipleUsers}
          >
            Remove selected users
          </Button>
        )}

        <div className="mt30">
           <UsersTableHeader updateBy={this.updateSortMode} role={this.props.user.role} />
          {displayUsers.length > 0 ? (
            displayUsers.map((officeMate, index) => (
              <OfficeMate
                key={officeMate._id}
                officeMate={officeMate}
                userRole={this.props.user.role}
                user={this.props.user}
                onUserRemoved={() =>
                  this.setState({
                    officeMates: this.state.officeMates.filter(
                      (u) => u._id !== officeMate._id
                    ),
                    displayUsers: this.state.displayUsers.filter(
                      (u) => u._id !== officeMate._id
                    ),
                  })
                }
                handleEmailChange={this.handleEmailChange}
                handleMobileNumberChange={this.handleMobileNumberChange}
                onRoleChange={this.handleRoleChange}
                userSelectedForRemove={this.userSelectedForRemove}
                removeChecked={usersRemove.includes(officeMate._id)}
                handleNameChange={this.handleNameChange}
                rowIndex={index}
                allowPadding
                {...this.props}
              />
            ))
          ) : (
            <EmptyTable
              title="No results found"
              subtitle="Try rephrasing your search to find users in your enterprise"
            />
          )}

          {this.renderPagination()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.profile,
});

const mapDispatchToProps = dispatch => {
  return {
    updateUserProfile: (userData) => dispatch(actionCreators.updateProfileInfoSuccess(userData))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Loading(withRouter(UsersList), axios));
